import React, { Component } from 'react'
import Link from "next/link";
import { Col, Card, Form, Button } from "react-bootstrap";
import { ErrorMessage, Field, Formik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import { locationActions, enquiryActions } from "../../_actions";
import BackDrop from "../BackDrop";

const renderStateList = (stateList) => {
  const obj = Object.entries(stateList).map(([key, value]) => ({
    key,
    value,
  }));
  return obj.map((item) => {
    return (
      <option key={item.key} value={item.key}>
        {item.value}
      </option>
    );
  });
};

class D2dContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
  }
  UNSAFE_componentWillMount() {
    this.props.getStateList();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { stateList } = nextProps;
    if (stateList) {
      this.setState({
        stateList: stateList,
      });
    }
  }
  render() {
    const recaptchaRef = React.createRef();
    const { d2dSaving, loading, partner } = this.props;
    const { stateList } = this.state;
    return (
      <>
        {loading ? <BackDrop /> : <></>}
        <div className='chkfrm'>
          <Formik
            initialValues={{
              firstname: "",
              lastname: "",
              organization: "",
              email: "",
              mobile_no: "",
              street_name1: "",
              street_name2: "",
              address_city: "",
              state: "",
              pin: "",
              feedback: "",
              declaration: "",
              recaptcha: "",
            }}
            validationSchema={Yup.object({
              firstname: Yup.string().required("required"),
              lastname: Yup.string().required("required"),
              email: Yup.string().required("required").email(),
              mobile_no: Yup.string()
                .required("required")
                .min(10, "Minimum 10 digit mobile number required")
                .max(10, "10 digit mobile number required"),
              street_name1: Yup.string().required("required"),
              address_city: Yup.string().required("required"),
              state: Yup.string().required("required"),
              pin: Yup.string().required("required"),
              feedback: Yup.string().required("required"),
              declaration: Yup.string().required("Accept"),
            })}
            onSubmit={async (values, { resetForm }) => {
              const token = await recaptchaRef.current.executeAsync();
              var formData = new FormData();
              for (let [key, value] of Object.entries(values)) {
                formData.append(key, value);
              }
              formData.append("recaptcha", token);
              if (!!partner) {
                formData.append("referrer", partner);
              }
              this.props.submitD2DForm(formData);
              resetForm();
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              touched,
              errors,
              values,
              setFieldValue,
            }) => (
              <Form onSubmit={handleSubmit}>
                <div className='row'>
                  <Form.Group as={Col} md="6">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder='First Name'
                      name="firstname"
                      id="firstname"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.firstname && !errors.firstname}
                      isInvalid={!!errors.firstname}
                      value={values.firstname}
                    />
                    <Form.Control.Feedback
                      type={errors.firstname ? "invalid" : "valid"}
                    >
                      {errors.firstname ? errors.firstname : "Looks good!"}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder='Last Name'
                      name="lastname"
                      id="lastname"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.lastname && !errors.lastname}
                      isInvalid={!!errors.lastname}
                      value={values.lastname}
                    />
                    <Form.Control.Feedback
                      type={errors.lastname ? "invalid" : "valid"}
                    >
                      {errors.lastname ? errors.lastname : "Looks good!"}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Your Organization/Company Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder='Your Organization/Company Name'
                      name="organization"
                      id="organization"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.organization && !errors.organization}
                      isInvalid={!!errors.organization}
                      value={values.organization}
                    />
                    <Form.Control.Feedback
                      type={errors.organization ? "invalid" : "valid"}
                    >
                      {errors.organization
                        ? errors.organization
                        : "Looks good!"}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Email ID</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder='Email ID'
                      name="email"
                      id="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.email && !errors.email}
                      isInvalid={!!errors.email}
                      value={values.email}
                    />
                    <Form.Control.Feedback
                      type={errors.email ? "invalid" : "valid"}
                    >
                      {errors.email ? errors.email : "Looks good!"}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Mobile No.</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder='Mobile No.'
                      name="mobile_no"
                      id="mobile_no"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.mobile_no && !errors.mobile_no}
                      isInvalid={!!errors.mobile_no}
                      value={values.mobile_no}
                    />
                    <Form.Control.Feedback
                      type={errors.mobile_no ? "invalid" : "valid"}
                    >
                      {errors.mobile_no ? errors.mobile_no : "Looks good!"}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Street Address 1</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder='Street Address 1'
                      name="street_name1"
                      id="street_name1"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.street_name1 && !errors.street_name1}
                      isInvalid={!!errors.street_name1}
                      value={values.street_name1}
                    />
                    <Form.Control.Feedback
                      type={errors.street_name1 ? "invalid" : "valid"}
                    >
                      {errors.street_name1
                        ? errors.street_name1
                        : "Looks good!"}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Street Address 2</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder='Street Address 2'
                      name="street_name2"
                      id="street_name2"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.street_name2 && !errors.street_name2}
                      isInvalid={!!errors.street_name2}
                      value={values.street_name2}
                    />
                    <Form.Control.Feedback
                      type={errors.street_name2 ? "invalid" : "valid"}
                    >
                      {errors.street_name2
                        ? errors.street_name2
                        : "Looks good!"}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder='City'
                      name="address_city"
                      id="address_city"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.address_city && !errors.address_city}
                      isInvalid={!!errors.address_city}
                      value={values.address_city}
                    />
                    <Form.Control.Feedback
                      type={errors.address_city ? "invalid" : "valid"}
                    >
                      {errors.address_city
                        ? errors.address_city
                        : "Looks good!"}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>State</Form.Label>
                    <Field id="state" name="state">
                      {({
                        field, // { name, value, onChange, onBlur }

                        form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

                        meta,
                      }) => (
                        <>
                          <Form.Control
                            as="select"
                            {...field}
                            isInvalid={!!errors[field.name]}
                            isValid={touched[field.name] && !errors[field.name]}
                            value={values.zone_id}
                          >
                            <option value="">Select One</option>
                            {stateList && renderStateList(stateList)}
                          </Form.Control>
                          <Form.Control.Feedback
                            type={errors[field.name] ? "invalid" : "valid"}
                          >
                            {errors[field.name]
                              ? errors[field.name]
                              : "Looks good!"}
                          </Form.Control.Feedback>
                        </>
                      )}
                    </Field>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>PIN Code</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder='PIN Code'
                      name="pin"
                      id="pin"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.pin && !errors.pin}
                      isInvalid={!!errors.pin}
                      value={values.pin}
                    />
                    <Form.Control.Feedback
                      type={errors.pin ? "invalid" : "valid"}
                    >
                      {errors.pin ? errors.pin : "Looks good!"}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="12">
                    <Form.Label>Device Details</Form.Label>
                    <Form.Control
                      as="textarea"
                      placeholder='Device Details'
                      rows={4}
                      name="feedback"
                      id="feedback"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isValid={touched.feedback && !errors.feedback}
                      isInvalid={!!errors.feedback}
                      value={values.feedback}
                    />
                    <Form.Control.Feedback
                      type={errors.feedback ? "invalid" : "valid"}
                    >
                      {errors.feedback ? errors.feedback : "Looks good!"}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      size="invisible"
                      sitekey={process.env.NEXT_PUBLIC_CAPTCHA_KEY}
                      badge="bottomleft"
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="12">
                    <label>
                      <Field type="checkbox" name="declaration" value="1" /> I
                      confirm that I am the owner of the device/s mentioned and
                      would like to donate these through Budli.in. All passwords
                      have been removed. I agree to the{" "}
                      <Link href="/terms-conditions">Terms and Conditions</Link>
                      .
                    </label>
                    <ErrorMessage
                      name="declaration"
                      component="div"
                      className="error"
                    />
                  </Form.Group>
                </div>
          
                  <div>
                    {d2dSaving ? (
                      <BackDrop />
                    ) : (
                      <Button type="submit" className='m-0 px-5 bg-default-blue py-2 border-0'>Submit</Button>
                    )}
                  </div>
                
              </Form>
            )}
          </Formik>
        </div>
      </>
    );
  }
}

const mapState = (state) => ({
  stateList: state.locations.items,
  loading: state.enquiries.loading,
  d2dSaving: state.enquiries.d2dSaving,
  partnerContent: state.enquiries.partnerContent,
});

const actionCreators = {
  getStateList: locationActions.getStateList,
  submitD2DForm: enquiryActions.submitD2DForm,
  getD2dPartnerContent: enquiryActions.getD2dPartnerContent,
};

export default connect(mapState, actionCreators)(D2dContactForm);